export default __webpack_public_path__ + "static/media/ic-check-outlined.de542569.svg";